import { render } from "./SmartFormLegacy.vue?vue&type=template&id=0a0b2f4a&lang=pug"
import script from "./SmartFormLegacy.vue?vue&type=script&lang=js"
export * from "./SmartFormLegacy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__